import React, { Component } from 'react';

class IconClose extends Component {
    render() {
        return (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>Close</title>
            <g id="icon-/-close" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Group-7" fill="#000000">
                <polygon id="Stroke-3" points="3.29289322 4.70710678 4.70710678 3.29289322 20.7071068 19.2928932 19.2928932 20.7071068"/>
                <polygon id="Stroke-5" points="19.2928932 3.29289322 20.7071068 4.70710678 4.70710678 20.7071068 3.29289322 19.2928932"/>
              </g>
            </g>
          </svg>
        )
    }
}

export default IconClose;